
/**
 * Module dependencies.
 */

import {
  REQUEST_WORKSPACES,
  RECEIVE_WORKSPACES,
  REQUEST_WORKSPACE,
  RECEIVE_WORKSPACE,
  FETCH_WORKSPACES_ERROR,
  CREATING_WORKSPACE,
  CREATED_WORKSPACE,
  CREATE_WORKSPACE_ERROR,
  UPDATING_WORKSPACE_BY_SLUG,
  UPDATE_WORKSPACE_BY_SLUG_ERROR,
  UPDATED_WORKSPACE_BY_SLUG,
  DELETING_WORKSPACE_BY_SLUG,
  DELETE_WORKSPACE_BY_SLUG_ERROR
} from 'actions'

/**
 * Expose `workspacesBySlug`.
 */

export default function workspacesBySlug (state = initialState(), action) {
  const { type, payload } = action
  switch (type) {
    case REQUEST_WORKSPACES:
      return {
        ...state,
        isRequesting: true,
        didRequestFail: false,
        didInvalidate: false
      }
    case RECEIVE_WORKSPACES:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: false,
        didInvalidate: false,
        data: toSlugMap(payload.data)
      }
    case REQUEST_WORKSPACE:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.workspaceSlug]: {
            ...initialState(),
            ...state.data[payload.workspaceSlug],
            isRequesting: true,
            didRequestFail: false
          }
        }
      }
    case RECEIVE_WORKSPACE:
      return {
        ...state,
        hasRequested: true,
        data: {
          ...state.data,
          [payload.response.slug]: {
            ...initialState(),
            hasRequested: true,
            data: payload.response
          }
        }
      }
    case FETCH_WORKSPACES_ERROR:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: true,
        didInvalidate: false,
        data: {}
      }
    case CREATING_WORKSPACE:
      return {
        ...state,
        isRequesting: true,
        didRequestFail: false,
        didInvalidate: false
      }
    case CREATE_WORKSPACE_ERROR:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: true,
        didInvalidate: false
      }
    case CREATED_WORKSPACE:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: false,
        didInvalidate: false,
        data: {
          ...state.data,
          [payload.data.slug]: {
            isRequesting: false,
            didInvalidate: false,
            didRequestFail: false,
            data: payload.data
          }
        }
      }
    case UPDATED_WORKSPACE_BY_SLUG:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            isRequesting: false,
            didInvalidate: false,
            didRequestFail: false,
            data: payload.data
          }
        }
      }
    case UPDATING_WORKSPACE_BY_SLUG:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            ...state.data[payload.slug],
            isRequesting: true,
            didInvalidate: false,
            didRequestFail: false
          }
        }
      }
    case UPDATE_WORKSPACE_BY_SLUG_ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            ...state.data[payload.slug],
            isRequesting: false,
            didInvalidate: true,
            didRequestFail: false
          }
        }
      }
    case DELETING_WORKSPACE_BY_SLUG:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            ...state.data[payload.slug],
            isRequesting: true,
            didInvalidate: false,
            didRequestFail: false
          }
        }
      }
    case DELETE_WORKSPACE_BY_SLUG_ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            ...state.data[payload.slug],
            isRequesting: false,
            didInvalidate: false,
            didRequestFail: true
          }
        }
      }
    default:
      return state
  }
}

/**
 * Initial state.
 */

function initialState () {
  return {
    isRequesting: false,
    didRequestFail: false,
    hasRequested: false,
    didInvalidate: false,
    data: {}
  }
}

/**
 * Map `array` by each item's slug.
 *
 * TODO(stephenmathieson): find a thing in npm that does this
 */

function toSlugMap (arr) {
  const bySlug = {}
  for (let i = 0; i < arr.length; i++) {
    bySlug[arr[i].slug] = {
      isRequesting: false,
      didRequestFail: false,
      hasRequested: true,
      didInvalidate: false,
      data: arr[i]
    }
  }
  return bySlug
}



// WEBPACK FOOTER //
// ./reducers/workspaces.js